import { __extends } from 'tslib';
import * as React from 'react';
import { UitkLayoutFlex } from 'uitk-react-layout-flex';
import { classNames } from 'uitk-react-utils';
import { UitkToolbarContainerTags } from './types.esm.js';
import styles from './uitk-toolbar.css';

var getClassNameList = classNames.bind(styles);
var UitkToolbarContainer = /** @class */ (function (_super) {
    __extends(UitkToolbarContainer, _super);
    function UitkToolbarContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkToolbarContainer.prototype.render = function () {
        var _a = this.props, id = _a.id, className = _a.className, children = _a.children, tag = _a.tag;
        // Renders the custom Tag
        var toolbarHeaderTag = ((tag && UitkToolbarContainerTags.get(tag)) ||
            UitkToolbarContainerTags.get('div'));
        var containerClassName = getClassNameList('uitk-toolbar', className);
        return (React.createElement(UitkLayoutFlex, { id: id, alignItems: "center", className: containerClassName, tag: toolbarHeaderTag }, children));
    };
    UitkToolbarContainer.displayName = 'UitkToolbarContainer';
    UitkToolbarContainer.defaultProps = {
        tag: 'div'
    };
    return UitkToolbarContainer;
}(React.Component));

export { UitkToolbarContainer };
